"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _index = require("./index");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    background-color: ", ";\n    text-transform: capitalize;\n    height: ", ";\n    width: ", ";\n    font-size: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Avatar = (0, _styledComponents["default"])(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      size = _ref.size,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["backgroundColor", "size"]);
  return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], props);
})(_templateObject(), function (props) {
  return props.backgroundColor;
}, function (props) {
  return _index.SIZE_TO_WIDTH_HEIGHT[props.size];
}, function (props) {
  return _index.SIZE_TO_WIDTH_HEIGHT[props.size];
}, function (props) {
  return _index.SIZE_TO_FONT_SIZE[props.size];
});
exports.Avatar = Avatar;